import Component from '../Component';
export default class CaptionComponent extends Component {
    reactivityOptions = {
        keepRatio: false
    };
}
